import * as React from 'react';
import { BestPlaceReportEmailContext } from 'shared/context/bestPlaceReportEmailContext';

export function useBestPlaceReportEmailContext() {
  return React.useContext(BestPlaceReportEmailContext);
}
